import ThingnarioPanel from '@/components/otherSources/ThingnarioPanel.vue';
import SolarEdgePanel from '@/components/otherSources/SolarEdgePanel.vue';
import SmartPVMSPanel from '@/components/otherSources/SmartPVMSPanel.vue';
import AUOPanel from '@/components/otherSources/AUOPanel.vue';

// 之後接新平台就在這裡加一列，元件放 components/otherSources/
var sources = [{
  key: 'thingnario',
  label: 'Thingnario 慧景',
  icon: 'fas fa-cloud',
  ready: true,
  component: ThingnarioPanel
}, {
  key: 'solaredge',
  label: 'SolarEdge',
  icon: 'fas fa-solar-panel',
  ready: true,
  component: SolarEdgePanel
}, {
  key: 'smartpvms',
  label: 'SmartPVMS 華為',
  icon: 'fas fa-industry',
  ready: true,
  component: SmartPVMSPanel
}, {
  key: 'auo',
  label: 'AUO 友達',
  icon: 'fas fa-charging-station',
  ready: true,
  component: AUOPanel
}];
export default {
  name: 'OtherSources',
  data: function data() {
    return {
      sources: sources,
      tabIndex: 0
    };
  }
};